/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicContact } from '../../models/public-contact';

export interface ConnectorGetContacts$Params {
  inventoryId: string;
}

export function connectorGetContacts(http: HttpClient, rootUrl: string, params: ConnectorGetContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PublicContact>>> {
  const rb = new RequestBuilder(rootUrl, connectorGetContacts.PATH, 'get');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PublicContact>>;
    })
  );
}

connectorGetContacts.PATH = '/apollon-connector/enums/contacts';
